<template>
  <div class="laureat" :style="{width: item.colWidth + '%'}" :class="[{noImage: !item.image.src}, 'mobright' + item.rightWidth, 'mobleft' + item.rightWidth, 'left' + item.leftWidth, 'right' + item.rightWidth]">
    <div class="laureatInner" :style="{paddingBottom: item.padding + '%'}">
      <router-link  @click.native="goToRoute($event, item.year.title, item.slug)" event="" :to="'/laureat/' + item.year.title + '/' + item.slug">
        <div v-if="item.image.src" class="laureatImage" :style="{paddingBottom: item.image.ratio + '%'}" v-lazyload>
          <LazyImage :source="item.image.src_low" :blur="item.image.src_blur" />
        </div>

        <div class="laureatInfo">
          <div>
            <em><span v-html="item.title"></span></em><br>
            <span v-html="item.domaine.title"></span>, <br>
            <span v-html="item.prix.title"></span>, <span v-html="item.year.title"></span>
          </div>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
import LazyImage from '@/components/LazyImage.vue'

export default {
  props: ['item'],

  components: {
    LazyImage
  },

  methods: {
    goToRoute (e, year, slug) {
      if (this.$route.name === 'current') {
        this.$router.push('/laureat/' + year + '/' + slug)
      } else {
        let rP = this.$route.path + '/' + year + '/' + slug
        this.$router.push(rP)
      }
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/css/variables.scss';

.laureat {
  padding: 2rem $padding 0;
  position: relative;
  float: left;
  display: flex;
  align-items: center;
  justify-content: center;

  a {
    display: block;
    color: white;
  }

  a:hover {
    font-style: normal;
  }
}

.left1 {
  padding-left: $unit;
}

.right1 {
  padding-right: $unit;
}

.left2 {
  padding-left: calc(#{$unit} * 2);
}

.right2 {
  padding-right: calc(#{$unit} * 2);
}

.left3 {
  padding-left: calc(#{$unit} * 3);
}

.right3 {
  padding-right: calc(#{$unit} * 3);
}

.laureat:nth-child(3n + 1) {
  padding-left: 0;
}

.laureat:nth-child(3n + 3) {
  padding-right: 0;
}

.noImage .laureatInner {
  border: $line;
  width: 100%;
  padding-bottom: 100%;
}

.laureat:nth-child(3n + 1) {
  clear: left;
}

.laureatImage img {
  position: absolute;
  width: 102%;
  height: 102%;
  top: -1%;
  left: -1%;
}

.laureatInner {
  position: relative;
  overflow: hidden;
  width: 100%;
}

.noImage .laureatInfo {
  opacity: 1;
  background-color: white;
  color: $maincolour;

  &:hover {
    background-color: $maincolour;
    color: white;
  }
}

.laureatInfo {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 1rem;
  background-color: $maincolour;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  opacity: 0;
  transition: opacity 0.2s, color 0.2s, background-color 0.2s;
}

.laureatInfo:hover {
  opacity: 1;
}

@media (hover: none) {
  .laureatInfo:hover {
    opacity: 0;
  }

  .noImage .laureatInfo:hover {
    background-color: white;
    opacity: 1;
    color: $maincolour;
  }
}

@media screen and (max-width: $breakPoint1) {
  .noImage .laureatInner {
    border: $line2;
  }

  .laureat {
    width: 100% !important;
  }

  .mobleft1 {
    padding-left: 0 !important;
  }

  .mobleft2 {
    padding-left: calc(#{$unit} * 2) !important;
  }

  .mobleft3 {
    padding-left: calc(#{$unit} * 3) !important;
  }

  .mobright1 {
    padding-right: 0 !important;
  }

  .mobright2 {
    padding-right: calc(#{$unit} * 1.5) !important;
  }

  .mobright3 {
    padding-right: calc(#{$unit} * 3) !important;
  }
}
</style>
